export { IcosHeaderDirective } from './header.directive'
export { IcosMainDirective } from './main.directive'
export { IcosFooterDirective } from './footer.directive'
export { IcosAsideDirective } from './aside.directive'
